class Shipping {
    public cityId?: number;
    public provinceId?: string;
    public city?: string;
    public postalCode?: string;
    public address?: string;
    public referenceName?: string;

    constructor(cityId?: number, provinceId?: string, city?: string, postalCode?: string, address?: string, referenceName?: string) {
        this.cityId = cityId || undefined;
        this.provinceId = provinceId || undefined;
        this.city = city || undefined;
        this.postalCode = postalCode || undefined;
        this.address = address || undefined;
        this.referenceName = referenceName || undefined;
    }
}

export default Shipping;
